var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.44,
    height: 24.47,
    viewBox: "0 0 21.44 24.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1782"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3699",
    d: "M1500.5 394.5a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4 4 4 0 0 1 4 4v2a4 4 0 0 1-4 4z",
    style: {
      fill: "none",
      stroke: "#191919",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    },
    transform: "translate(-1489.81 -383.75)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3700",
    d: "M1496.66 397.5a.71.71 0 0 1 .58.32 4 4 0 0 0 6.52 0 .71.71 0 0 1 .58-.32 6.16 6.16 0 0 1 6.16 6.16v2.81a1 1 0 0 1-1 1h-17.94a1 1 0 0 1-1-1v-2.81a6.16 6.16 0 0 1 6.16-6.16z",
    style: {
      fill: "none",
      stroke: "#191919",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    },
    transform: "translate(-1489.81 -383.75)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0690348c6855c5bcf9e9467a4d46af87.svg";
export { ForwardRef as ReactComponent };